import axios from 'axios';
import { getAuthIfLoaded } from '../config/firebase';

// Separate axios instance with /api as base — the oauth endpoints live at
// /api/oauth/* and /api/me/oauth/connections, not under /api/v1.
const baseURL = (process.env.REACT_APP_API_URL || '/api/v1').replace(/\/v1$/, '');

const oauthApi = axios.create({
  baseURL,
  headers: { 'Content-Type': 'application/json' },
  timeout: 30000,
});

oauthApi.interceptors.request.use(async (config) => {
  const authInstance = await getAuthIfLoaded();
  const u = authInstance?.currentUser;
  if (u) {
    const token = await u.getIdToken(false);
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

const oauthService = {
  preview: (params) => oauthApi.get('/oauth/authorize/preview', { params }),
  authorize: (body) => oauthApi.post('/oauth/authorize', body),
  listConnections: () => oauthApi.get('/v1/me/oauth/connections'),
  revokeConnection: (clientId) =>
    oauthApi.delete(`/v1/me/oauth/connections/${encodeURIComponent(clientId)}`),
};

export default oauthService;
